import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Directive, ViewContainerRef } from '@angular/core';
import { ISSUE, ISSUANCE_INVESTOR } from '../../models/issuance';
import { SIMPLE_INVESTOR, ACCOUNTS_INVESTOR } from '../../models/investor';
import { ISSUE_ACCOUNTS } from '../../models/account';
import { Http, Response, Headers } from '@angular/http';
import { HeaderService } from '../../header.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as Globals from '../../globals';
declare var $: any;

@Component({
  selector: 'app-upload-checker-hasil',
  templateUrl: './upload-checker-hasil.component.html',
  styleUrls: ['./upload-checker-hasil.component.css']
})
export class UploadCheckerHasilComponent implements OnInit {

  param: any;
  @Input() seriesId: number;
  @Input() paramSeries: any;
  investors: SIMPLE_INVESTOR[];
  issue: ISSUE;
  issueInvestor: ISSUANCE_INVESTOR;
  bids: ISSUANCE_INVESTOR[];
  accountsInvestor: ACCOUNTS_INVESTOR[]; 
  issuanceBids: ISSUE[];
  accountsSec: ISSUE_ACCOUNTS[];
  accountsBank: ISSUE_ACCOUNTS[];
  @Input() invId: number;
  @Output() refreshParent = new EventEmitter;
  @Input() userProfile: any;
  loading: boolean;
  p:any;
  errAmt: boolean;
  search: string;
  editIssue: boolean;
  selectedBidId: number;
  urlFile = Globals.archiveUrl + 'bids?code=';
  showError: boolean;
  subtab: number = 1;
  @Input() authMenu: any;
  @ViewChild("fileInput") fileInput: any;
  @ViewChild("issueAmt") issueAmtEl: any;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService) {
    this.toastr.setRootViewContainerRef(vRef);
  }
  ngOnInit() {
    /* this.investors = [];
    this.issuanceBids = [];
    //this.newRedeem();
    this.issue = new ISSUE(0, 0, 0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID);
    this.paramSeries.MAX_PCENT_ORG = this.paramSeries.MAX_PCENT;
    this.newIssueInvestor();
    if (this.invId > 0) {
      this.getIssueInvestor();
    } */
  }
  getInvestor() {
    if (this.search.length > 0) {
      this.loading = true;
      this.http.get(Globals.serviceUrl + 'ritel/investor?skip=0&take=50&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.investors = res.json();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  newIssue() {
    let fi = this.fileInput.nativeElement;
    fi.value = null;
    this.issue = new ISSUE(0, 0, 0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID,null, null);
    var item: any;
    var acctSec: any;
    var acctBank: any;
    if (this.accountsInvestor.length > 0) {
      item = this.accountsInvestor[0];
    }
    if (this.accountsSec.length > 0) {
      acctSec = this.accountsSec[0];
      this.issue.SEC_ACCT_ID = acctSec.SEC_ACCT_ID;
    }
    if (this.accountsBank.length > 0) {
      acctBank = this.accountsBank[0];
      this.issue.INV_ACCT_ID = acctBank.BANK_ACCT_ID;
    }
    this.issue.BID_AMT = item.BID_AMT;
  }
  newIssueInvestor() {
    this.issueInvestor = new ISSUANCE_INVESTOR(null, null, null, null, null, null, null, null, null, 0, null, null, null, null, null, null, null, null, null);
    this.bids = [];
  }
  loadParent() {
    this.refreshParent.emit();
  }
  getIssueInvestor() {
    this.loading = true;
    this.newIssueInvestor();
    this.getAccountsSec();
    this.getAccountsBank();
    this.http.get(Globals.serviceUrl + 'ritel/issueinvestor?invId=' + this.invId + '&seriesId=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.accountsInvestor = res.json();
        if (this.accountsInvestor.length == 0) {
          this.toastr.warning('Data tidak ditemukan');
        } else {
          this.newIssue();
          for (var i = 0; i < this.accountsInvestor.length; i++) {
            if (this.accountsInvestor[i].ISSUED_TYP == '2') {
              this.issueInvestor.IDTY_NO = this.accountsInvestor[i].IDTY_NO;
              this.issueInvestor.INV_NAME = this.accountsInvestor[i].INV_NAME;
              this.issueInvestor.SID = this.accountsInvestor[i].SID;
              this.issueInvestor.SEC_REK_NO = this.accountsInvestor[i].SEC_REK_NO;
              this.issueInvestor.ALT_AMT += this.accountsInvestor[i].ALT_AMT;
              this.issueInvestor.BID_AMT += this.accountsInvestor[i].BID_AMT
            } else {
              this.issueInvestor.IDTY_NO = this.accountsInvestor[i].IDTY_NO;
              this.issueInvestor.INV_NAME = this.accountsInvestor[i].INV_NAME;
              this.issueInvestor.SID = this.accountsInvestor[i].SID;
              this.issueInvestor.BANK_REK_NO = this.accountsInvestor[i].BANK_REK_NO;
              this.issueInvestor.ALT_AMT += this.accountsInvestor[i].ALT_AMT;
              this.issueInvestor.BID_AMT += this.accountsInvestor[i].BID_AMT
            }
          }
          this.getIssuanceBids();
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getAccountsSec() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/accountsSec?invid=' + this.invId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
    .subscribe((res: Response) => {
      this.accountsSec = res.json();
      this.loading = false;
    }, err => {
      console.log(err);
      this.toastr.error(Globals.errorMessage(err));
      this.loading = false;
    });
  }

  getAccountsBank() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/accountsBank?invid=' + this.invId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
    .subscribe((res: Response) => {
      this.accountsBank = res.json();
      this.loading = false;
    }, err => {
      console.log(err);
      this.toastr.error(Globals.errorMessage(err));
      this.loading = false;
    });
  }

  getIssuanceBids() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/issuancebids?invid=' + this.invId + '&seriesId=' + this.seriesId + '&paId=' + this.userProfile.PA_ID + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.bids = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  setIssue(item: any) {
    let fi = this.fileInput.nativeElement;
    fi.value = null;
    this.issue.BID_ID = item.BID_ID;
    this.issue.INV_ACCT_NO = item.BANK_REK_NO;
    this.issue.SEC_ACCT_NO = item.SEC_REK_NO;
    //this.issue.ALT_AMT = item.ALT_AMT;
    this.issue.BID_AMT = item.BID_AMT;
  }
  changeAcctDana() {
    var item: any;
    for (var i = 0; i < this.accountsBank.length; i++) {
      if (this.accountsBank[i].BANK_ACCT_ID == this.issue.INV_ACCT_ID) {
        item = this.accountsBank[i];
        break;
      }
    }
    this.issue.INV_ACCT_ID = item.BANK_ACCT_ID;
  }

  changeAcctSb() {
    var item: any;
    for (var i = 0; i < this.accountsSec.length; i++) {
      if (this.accountsSec[i].SEC_ACCT_ID == this.issue.SEC_ACCT_ID) {
        item = this.accountsSec[i];
        break;
      }
    }
    this.issue.SEC_ACCT_ID = item.SEC_ACCT_ID;
  }


  saveIssue() {
    this.loading = true;
    let fi = this.fileInput.nativeElement;
     if (this.issue.BID_ID == 0) {
      this.http.post(Globals.serviceUrl + 'ritel/bids?seriesId=' + this.seriesId + '&invId=' + this.invId , this.issue, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.uploadFile(res.json().BID_ID, fi);
        $('#issue').modal('hide');
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
    }
    else {
      this.http.put(Globals.serviceUrl + 'ritel/bids?id=' + this.issue.BID_ID + '&invId=' + this.invId , this.issue, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.uploadFile(res.json().BID_ID, fi);
          $('#issue').modal('hide');
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

  deleteIssue() {
    this.http.delete(Globals.serviceUrl + 'ritel/bids?id=' + this.issue.BID_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        $('#issue').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.getIssueInvestor();
        this.loadParent();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
      });
  }

  uploadFile(id: number, fi: any) {
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      let input = new FormData();
      input.append("file", fileToUpload);
      let headers = new Headers({ 'Content-Type': 'multipart/form-data' });
      this.http.put(Globals.archiveUrl + "bids?id=" + id, input)
        .subscribe((res: Response) => {
          this.toastr.success(Globals.successMessage());
          this.getIssueInvestor();
          this.loadParent();
        }, err => {
          console.log(err);
          if (err.status == 400) {
            this.toastr.error('File harus berformat pdf, tif, tiff.');
          }
          else if (err.status == 406) {
            this.toastr.error('File pdf maksimal berukuran 50MB.');
          }
          else {
            //this.toastr.error(Globals.errorMessage(err));
            this.toastr.error('Upload gagal. Silahkan dicoba lagi.');
          }
        });

    } else {
      this.toastr.success(Globals.successMessage());
      this.loadParent();
      this.getIssueInvestor();
    }
    this.loading = false;
  }

  checkPcent(val: any) {
    if (isNaN(val) || val == '') {
      this.issue.BID_AMT = 0;
    } else {
      this.issue.BID_AMT = (val / 100) * this.issue.ALT_AMT;
    }
  }

  checkIssueAmt(val: any) {
    if (isNaN(val) || val == '') {
      //this.issue.PCENT = 0;
      this.issue.BID_AMT = 0;
    } 
    // else {
    // this.issue.PCENT = (val / this.issue.ALT_AMT) * 100;
    // }
  }

  generateReport(format: string) {
    this.loading = true;
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",invId:"' + this.invId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'rpt12?id=' + this.param.TICKET_ID, '_blank');
        this.loading = false;
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  onFocus() {
    this.editIssue = true;
    this.issueAmtEl.nativeElement.focus();
  }

  
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/upload-checker/upload-checker-hasil/upload-checker-hasil.component.ts